import React from "react";
import { ToastContainer } from "react-toastify";

const LoyaltySettings = ({
  loyalty,
  loyaltyForm,
  handleLoyaltyChange,
  handleUpdateLoyalty,
  formatAmount,
}) => {
  return (
    <>
    <ToastContainer/>
 
    <div className="space-y-6 montserrat-font-1">
      {/* ---------------- LOYALTY LIST ---------------- */}
      {loyalty && loyalty.length > 0 ? (
        <div className="grid md:grid-cols-2 gap-4">
          {loyalty.map((item, index) => (
            <div
              key={index}
              className="bg-white border rounded-xl p-5 shadow-sm"
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-3 border-b pb-2">
                <h2 className="text-green-700 font-semibold">
                  Loyalty Points
                </h2>

                <button className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded">
                  Remove
                </button>
              </div>

              {/* Body */}
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Points:</span>
                  <span>{item.points}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Value (₹):</span>
                  <span>₹{formatAmount(item.value)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Created On:</span>
                  <span>{item.created_on}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-red-500">
          No loyalty points found
        </div>
      )}

      {/* ---------------- FORM ---------------- */}
      <div className="bg-white p-6 rounded-2xl">
        <h2 className="text-green-700 font-semibold text-lg mb-6">
          Update Loyalty Points
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Points */}
          <div>
            <label className="text-sm text-gray-700">
              Loyalty Points
            </label>
            <input
              type="text"
              name="points"
              value={loyaltyForm.points}
              onChange={handleLoyaltyChange}
              placeholder="Enter Loyalty Points"
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            />
          </div>

          {/* Value */}
          <div>
            <label className="text-sm text-gray-700">
              Loyalty Points Value in Rupees
            </label>
            <input
              type="text"
              name="value"
              value={loyaltyForm.value}
              onChange={handleLoyaltyChange}
              placeholder="Enter Value in ₹"
              className="w-full mt-1 px-3 py-2 border rounded-lg"
            />
          </div>
        </div>

        {/* Button */}
        <div className="mt-6">
          <button
            onClick={handleUpdateLoyalty}
            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
          >
            Update Loyalty Points
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default LoyaltySettings;